import { FC } from "react";

import { StyledSummary } from "./styles";

export const SubscriptionSummary: FC = ({ children }) => <StyledSummary>{children}</StyledSummary>;
